import { render, staticRenderFns } from "./AssetStatus.vue?vue&type=template&id=0b549bf1&"
import script from "./AssetStatus.vue?vue&type=script&lang=js&"
export * from "./AssetStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports